<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar a transformação de item de código <b>{{this.entry.code}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(storageTransfer) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_ITEM_TRANSFORMATION_MUTATION,
          variables: {
            id: storageTransfer.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyItemTransformation.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_ITEM_TRANSFORMATION_MUTATION = gql `
  mutation($id: ID!) {
    destroyItemTransformation(id: $id) {
      itemTransformation {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>